import styles from './JourneyTimeline.module.css';

const JOURNEY = [
  ['2007', 'Shipping / Receiving Clerk', 'End-user side', 'Hired to fill a lot of holes — and thrown straight into NetSuite as the daily end user. Self-taught from day one.'],
  ['2008', 'Warehouse Manager', 'End-user side', 'Ran the warehouse and the NetSuite behind it — receiving, inventory, and fulfillment.'],
  ['2009', 'Tech Support Lead · NetSuite Admin & Developer', 'End-user side', 'Took over the system itself — first as admin, then writing my first scripts. All self-taught.'],
  ['2010', 'Internal Sales', 'End-user side', 'A turn through sales — learning the business from the revenue side, still living in NetSuite.'],
  ['2011', 'Full-Time NetSuite Admin & Developer', 'End-user side', 'Went all-in — customizing, scripting, and administering NetSuite full time.'],
  ['2014', 'NetSuite Developer', 'NetSuite Partner', 'Moved to the partner side — building for many clients instead of one.'],
  ['2015', 'NetSuite Solutions Architect', 'NetSuite Partner', 'Designing end-to-end solutions and leading implementations across industries.'],
  ['2019', 'Director of Software Development', 'End-user side · NetSuite', 'Back on the end-user side, leading a software team built around NetSuite.'],
  ['2022', 'SuiteApp Developer', 'NetSuite Partner', 'Employed at a partner, building and publishing SuiteApps to the NetSuite marketplace.'],
  ['2021 → Now', 'Independent NetSuite Consultant', 'JP Custom Works', 'Out on my own — NetSuite consulting, custom development, and AI enablement; end users and partners alike. Now loving every minute of independence.'],
];

export default function JourneyTimeline() {
  return (
    <div className={`${styles.journey} reveal`}>
      <div className={styles.journeyHead}>
        <span className="eyebrow">The journey</span>
        <h3 className={styles.journeyTitle}>From shipping clerk to NetSuite expert</h3>
        <p className={styles.journeySub}>
          One platform, learned from the floor up — hired to fill a lot of holes, then self-taught
          every step from there.
        </p>
      </div>
      <ol className={styles.timeline}>
        {JOURNEY.map(([year, role, org, desc], i) => {
          const isNow = i === JOURNEY.length - 1;
          return (
            <li className={`${styles.tlItem} ${isNow ? styles.tlNow : ''}`} key={year}>
              <div className={styles.tlRail}>
                <span className={styles.tlDot} />
              </div>
              <div className={styles.tlBody}>
                <span className={styles.tlYear}>{year}</span>
                <h4>{role}</h4>
                <div className={styles.tlOrg}>{org}</div>
                <p>{desc}</p>
              </div>
            </li>
          );
        })}
      </ol>
    </div>
  );
}
